<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.form.servicosEnfermagem.concat(data.model.servicosEnfermagem)"
            hide-filters
            hide-pagination
            tag="div"
        >
            <template v-slot:cell(info)="row">
                <div v-if="Number.isInteger(row.item.id)">
                    <rkm-icon
                        :id="`pronto-atendimento-servico-enfermagem-info-${row.item.id}`"
                        font-scale="1.5"
                        icon="info-circle"
                    />

                    <rkm-popover
                        :target="`pronto-atendimento-servico-enfermagem-info-${row.item.id}`"
                        triggers="hover"
                    >
                        <div>{{ row.item.centroCusto.setor.nome }}</div>
                        <div><rkm-icon icon="user" /> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                        <div>Class. risco: {{ row.item.classificacaoRisco.nome }}</div>
                        <div><rkm-icon :icon="['far', 'clock']" /> {{ row.item.dataHora }}</div>
                    </rkm-popover>
                </div>
            </template>

            <template v-slot:cell(codigo)="row">
                <div v-if="row.item.procedimento.codigo">
                    {{ row.item.procedimento.codigo | formatProcedimento }}
                </div>
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    :disabled="Number.isInteger(row.item.id)"
                    @click.stop="$emit('edit', row.item)"
                    color="primary"
                    title="Editar"
                    small
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="Number.isInteger(row.item.id)"
                    @click.stop="handleDestroy(row.item)"
                    color="danger"
                    title="Excluir"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
// Filters.
import formats from '@/filters/formats'

export default {
    data: () => ({
        fields: [
            { key: 'info', label: '#', class: 'col-min text-center' },
            { key: 'codigo', label: 'Código', class: 'col-min' },
            { key: 'procedimento.nome', label: 'Nome' },
            { key: 'status.nome', label: 'Status' },
            { key: 'actions', label: 'Ações', class: 'col-min' },
        ],
    }),
    filters: {
        ...formats,
    },
    methods: {
        handleDestroy(item) {
            const destroy = () => new Promise(resolve => {
                const index = this.data.model.servicosEnfermagem.findIndex(procedimento => procedimento.id === item.id)
                resolve(this.data.model.servicosEnfermagem.splice(index, 1))
            })

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>